export default __webpack_public_path__ + "static/media/help-you.da0c1f8f.png";